import { PaymentReference } from "../modules/accounts/types";

export const calculateInvoiceTotalPaid = (
    paymentReferences: PaymentReference[] = [],
    initialReceivedAmount: number = 0
  ): number => {
    // Calculate sum of all payment reference amounts
    const referencesTotal = paymentReferences.reduce(
      (sum, ref) => sum + (ref.amount || 0), 
      0
    );
    
    // Return total = initial payment + all reference payments
    return (initialReceivedAmount || 0) + referencesTotal;
  };